<ng-template #machineIconComponent>
  @if (instance().icon) {
    <div class="zn-col-auto p-0">
      <zenith-object-icon [attr.zn-icon-name]="instance().icon"></zenith-object-icon>
      <div class="flex-center">
        <ng-content select="[belowObjectIcon]"></ng-content>
      </div>
    </div>
  }
</ng-template>

<div class="zn-row">
  @if (machineIcon() === 'left') {
    <ng-container *ngTemplateOutlet="machineIconComponent"></ng-container>
  }

  <div class="zn-col" [class.clickable]="infoClickable()" (click)="infoClick.emit()">
    <span class="fw-bold" data-testid="object-id">{{ instance().objectIdAndDisplayName }}</span>
    @if (!showBlockedReason() && instance().blocked) {
      <span class="zn-text-size-75 zn-text-color-error text-uppercase fw-bold ml-3" data-testid="blocked-status">
        <zenith-icon appearance="error" icon-name="block" class="zn-text-size-100"></zenith-icon>
        {{ 'components.instance.blocked' | translate }}
      </span>
    }
    <br />

    <span class="zn-text-color-subdued" data-testid="instance-info">
      <!-- TODO DRA-3532 : machine serial number can be null -->
      {{ instance().serialNumber }} • {{ instance().model }} • {{ instance().manufacturer }}
    </span>
    <br />

    @if (instance().modelGroupName) {
      <span class="zn-text-color-subdued" data-testid="model-group-info">
        {{ instance().modelGroupName }}
      </span>
      <br />
    }

    @if (showEngineType() && instance().engineType) {
      <span class="zn-text-color-subdued" data-testid="engine-type">
        {{ 'MACHINE.ENGINE_TYPE.' + instance().engineType | translate }}
      </span>
      <br />
    }

    @if (showVendor() && instance().vendor) {
      <div class="mt-2" data-testid="vendor">
        <span class="zn-text-color-subdued">
          {{ instance().vendor.name }}
        </span>
        <zenith-badge zn-emphasis="light">{{ instance().vendor.vendorGroupCode }}</zenith-badge>
      </div>
    }

    @if (showLocation()) {
      <app-instance-location [instance]="instance()"></app-instance-location>
    }

    <ng-content select="[belowInfo]"></ng-content>
  </div>

  @if (machineIcon() === 'right') {
    <ng-container *ngTemplateOutlet="machineIconComponent"></ng-container>
  }

</div>

@if (showBlockedReason() && instance().blocked) {
  <div class="zn-row">
    <div class="zn-col">
      <span class="zn-text-color-error zn-text-size-100 text-uppercase fw-bold" data-testid="blocked-reason">
        {{ instance().blockedReason }}
      </span>
    </div>
  </div>
}
